import * as React from 'react';

const HeartFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 1.7C10.82-.35 8 2.74 8 2.74S5.19-.35 2 1.7c-2.93 1.88-2.48 5.86.33 8.5A83.4 83.4 0 0 0 8 15s3.04-2.32 5.67-4.8c2.81-2.64 3.26-6.62.34-8.5" }));
HeartFilled16.Size = 16;
HeartFilled16.Title = "HeartFilled";

export { HeartFilled16 as default };
